import urlTemplate from 'url-template';

/**
 * Call this function to expand and encode the url with certain path variables.
 *
 * @param {string} href
 * @param {object} expand
 *
 * @return {string} expanded url
 */
export const expandUrlTemplate = (href: string, expand: Record<string, unknown>): string => {

   const template = urlTemplate.parse(href);
   return template.expand(expand);
};
